import { createEventFactory, createName } from '@cp/shared/tracking';
import { TariffViewModel } from '@common/model/billing/tariff/view';
import { getTariffTermLabel } from '@cp/entities/tariff';

type MinimalTariffInfo = Pick<TariffViewModel, 'period'>;
const injectTariff = (tariff?: MinimalTariffInfo | null): Record<string, string> => (tariff ? { 'Тариф': getTariffTermLabel(tariff) } : {});

export const BillingEvents = {
  TariffSelect: createEventFactory<Record<string, string>, MinimalTariffInfo | undefined>(
    {
      name: createName('billing', 'tariff', 'select'),
      goalId: 'nazhatie_na_variant_tarifa_v_popape',
      goalName: 'Нажатие на вариант тарифа в попапе',
    },
    injectTariff,
  ),
  CardBindingModalOpen: createEventFactory({
    name: createName('billing', 'cardModal', 'open'),
    nonInteraction: true,
    goalId: 'poyavlenie_popapa_s_privyazkoj_karty',
    goalName: 'Появление попапа с привязкой карты',
  }),
  CardBindingSend: createEventFactory({
    name: createName('billing', 'card', 'submit'),
    goalId: 'nazhatie_na_knopku_privyazat_kartu',
    goalName: 'Нажатие на кнопку "Привязать карту"',
  }),
  CheckoutModalOpen: createEventFactory({ name: 'billing-checkout-open' }),
  CheckoutModalSend: createEventFactory<Record<string, string>, MinimalTariffInfo | undefined>(
    { name: 'billing-checkout-send' },
    injectTariff,
  ),
  PaymentSuccess: createEventFactory<Record<string, string>, MinimalTariffInfo | undefined | null>(
    {
      name: createName('billing', 'payment', 'success'),
      goalId: 'uspeshnaya_oplata',
      goalName: 'Успешная оплата',
    },
    injectTariff,
  ),
  SubscriptionCancel: createEventFactory({
    name: createName('billing', 'subscription', 'cancel'),
    goalId: 'nazhatie_na_knopku_otmenit_podpisku_',
    goalName: 'Нажатие на кнопку "Отменить подписку" ',
  }),
} as const;
